var map = {
	"./alert.svg": 9293,
	"./biohazard.svg": 7217,
	"./exclamation.svg": 5524,
	"./info.svg": 8157,
	"./ok.svg": 9247,
	"./radiation.svg": 3082,
	"./stop.svg": 5553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9003;